import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const FEATURE_DETAILS = {
    products: {
        title: 'Produtos Ilimitados',
        description: 'O plano Básico permite apenas 50 produtos cadastrados.',
        benefits: [
            'Cadastre quantos produtos quiser',
            'Organize seu catálogo sem limites',
            'Adicione novos itens sempre que precisar'
        ],
        icon: <i className="bi bi-box-seam"></i>
    },
    clients: {
        title: 'Clientes Ilimitados',
        description: 'O plano Básico permite apenas 20 clientes cadastrados.',
        benefits: [
            'Gerencie quantos clientes precisar',
            'Expanda sua base sem restrições',
            'Acompanhe todos seus relacionamentos'
        ],
        icon: <i className="bi bi-people"></i>
    },
    orders: {
        title: 'Gestão de Pedidos',
        description: 'A gestão de pedidos está disponível apenas nos planos pagos.',
        benefits: [
            'Crie e gerencie pedidos completos',
            'Acompanhe status de entregas',
            'Tenha controle total das vendas',
            'Compartilhe links de pedidos com clientes'
        ],
        icon: <i className="bi bi-clipboard-check"></i>
    },
    dashboardCharts: {
        title: 'Dashboard com Gráficos',
        description: 'Gráficos avançados estão disponíveis nos planos pagos.',
        benefits: [
            'Visualize evolução mensal',
            'Gráficos de receita vs despesas',
            'Distribuição de produtos',
            'Análise de despesas por categoria',
            'Ranking de produtos mais vendidos'
        ],
        icon: <i className="bi bi-bar-chart"></i>
    },
    reports: {
        title: 'Relatórios Avançados',
        description: 'Relatórios completos disponíveis nos planos pagos.',
        benefits: [
            'Análise detalhada de lucratividade',
            'Relatórios customizados',
            'Exportação completa de dados',
            'Insights de negócio'
        ],
        icon: <i className="bi bi-graph-up"></i>
    },
    exportData: {
        title: 'Exportação de Dados',
        description: 'Exporte seus dados para análise externa.',
        benefits: [
            'Exportação em CSV e Excel',
            'Relatórios para contabilidade',
            'Backup completo dos dados',
            'Análises personalizadas'
        ],
        icon: '💾'
    }
};

const PLANS_INFO = {
    profissional: {
        name: 'Profissional',
        price: 'R$ 29,90',
        period: '/mês',
        color: 'primary',
        highlight: true
    },
    premium: {
        name: 'Premium',
        price: 'R$ 59,90',
        period: '/mês',
        color: 'success'
    }
};

export default function UpgradeModal({ show, onClose, feature = 'products' }) {
    const { userProfile } = useAuth();
    const currentPlan = userProfile?.plan || 'basico';

    const featureInfo = FEATURE_DETAILS[feature] || FEATURE_DETAILS.products;

    if (!show) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                className="modal-backdrop fade show"
                onClick={onClose}
                style={{ zIndex: 1050 }}
            />

            {/* Modal */}
            <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{ zIndex: 1055 }}
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                            />
                        </div>

                        <div className="modal-body text-center px-4 pb-4">
                            {/* Icon */}
                            <div className="mb-3" style={{ fontSize: '4rem' }}>
                                {featureInfo.icon}
                            </div>

                            {/* Title */}
                            <h3 className="mb-3">
                                {featureInfo.title}
                            </h3>

                            {/* Description */}
                            <p className="text-muted mb-4">
                                {featureInfo.description}
                            </p>

                            {/* Benefits List */}
                            <div className="mb-4">
                                <h5 className="mb-3">O que você ganha:</h5>
                                <ul className="list-unstyled text-start" style={{ maxWidth: '500px', margin: '0 auto' }}>
                                    {featureInfo.benefits.map((benefit, index) => (
                                        <li key={index} className="mb-2">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            {benefit}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Plans */}
                            <div className="row g-3 mb-4">
                                {Object.entries(PLANS_INFO).map(([planKey, planInfo]) => (
                                    <div key={planKey} className="col-md-6">
                                        <div
                                            className={`card h-100 ${planInfo.highlight ? 'border-primary border-2 shadow' : ''}`}
                                        >
                                            <div className="card-body">
                                                {planInfo.highlight && (
                                                    <div className="badge bg-primary mb-2">
                                                        Mais Popular
                                                    </div>
                                                )}
                                                <h5 className="card-title">{planInfo.name}</h5>
                                                <div className="mb-3">
                                                    <span className="h3 fw-bold">{planInfo.price}</span>
                                                    <span className="text-muted">{planInfo.period}</span>
                                                </div>
                                                <Link
                                                    to={currentPlan === 'basico' ? '/planos' : '/assinatura'}
                                                    className={`btn btn-${planInfo.color} w-100`}
                                                    onClick={onClose}
                                                >
                                                    {currentPlan === 'basico' ? 'Assinar Agora' : 'Fazer Upgrade'}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Footer Info */}
                            <p className="text-muted small mb-0">
                                Cancele quando quiser • Sem fidelidade • Suporte prioritário
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
